// src/components/Categories.js (Updated with GIF imports and paths)

import React from 'react';
import { Link } from 'react-router-dom';
import CategoryCard from './CategoryCard';
import './Categories.css'; 
import { motion } from 'framer-motion'; // <-- Framer Motion Import

// --- 1. Import GIF Assets ---
import TechGif from '../assets/icons/tech.gif';
import BusinessGif from '../assets/icons/business.gif';
import MedicalGif from '../assets/icons/medical.gif';
import SportsGif from '../assets/icons/sports.gif';
import ContentGif from '../assets/icons/content.gif';
import CreativeGif from '../assets/icons/creative.gif';


// --- 2. Update Data with GIF Paths ---
const categoriesData = [
    { 
      title: 'Technology & Software', 
      description: 'Coding, AI/ML, Web Development, and Cyber Security paths.', 
      icon: TechGif 
    },
    { 
      title: 'Business & Entrepreneurship', 
      description: 'Startup strategies, Marketing, Finance, and leadership development.', 
      icon: BusinessGif 
    },
    { 
      title: 'Healthcare & Medical Field', 
      description: 'Nursing, specialized medicine, public health, and research.', 
      icon: MedicalGif 
    },
    { 
      title: 'Sports & Athletic Training', 
      description: 'Performance optimization, coaching, nutrition, and fitness science.', 
      icon: SportsGif 
    },
    { 
      title: 'Content Creation & Media', 
      description: 'YouTube, podcasting, streaming (Twitch/Gaming), and visual design.', 
      icon: ContentGif 
    },
    { 
      title: 'Creative Arts & Design', 
      description: 'Graphic design, music production, writing, and digital art.', 
      icon: CreativeGif 
    },
];

// =======================================
// FRAMER MOTION VARIANTS (Parent Container)
// =======================================
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.1,   
      staggerChildren: 0.07, 
    }
  }
};


const Categories = () => {
  return (
    <section className="categories-section section-padding">
      <h2 className="section-heading">Explore Any Aspiration</h2>
      <p className="section-subtext">Choose your path and receive instant, personalized guidance.</p>
      
      <motion.div 
        className="categories-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible" // Start animation when component is visible
        viewport={{ once: true, amount: 0.2 }} // Trigger when 20% of the grid is visible
      >
        {categoriesData.map((category) => (
          <CategoryCard
            key={category.title}
            title={category.title}
            description={category.description}
            icon={category.icon} 
          />
        ))}
      </motion.div>
      
      <div className="categories-footer">
          <Link to="/explore" className="btn-secondary">
            View All Categories
          </Link>
      </div>
    </section>
  );
};

export default Categories;